import React from 'react';
import PropTypes from 'prop-types';

const BlockPlaceholder = ({ children, minHeight = 0 }) => {
    return (
        <div className="block-placeholder" style={{ minHeight }}>
            {children}
        </div>
    );
};

BlockPlaceholder.propTypes = {
    children: PropTypes.node,
    minHeight: PropTypes.number
};

export default BlockPlaceholder;
